// University of South Florida's undergraduate majors (#2652). Read on
// 2026-10-01 from the official 2026-2027 Undergraduate Catalog
// (catalog.usf.edu, catoid=25), Programs by College: each college's page lists
// its programs with the degree. Every bachelor's program is kept once; a
// major offered with several concentrations ("Biology B.S., with Animal
// Biology Concentration") appears once under its own name and degree. Minors,
// certificates, ROTC minors and the Exploratory Curriculum pathways (not
// majors) are left out. Degree abbreviations are the catalog's own (B.S.,
// B.S.C.S., B.F.A, ...). The College of Nursing lists three B.S.N.
// pathways; all three are kept as the catalog names them. Two official major
// names contain "AI": "Artificial Intelligence (AI)" (B.S.A.I.) and
// "Artificial Intelligence (AI) and Business Analytics" (B.S.); they are kept
// as written. The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-south-florida",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in USF's 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Concentrations are folded into their major; minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Bellini College of Artificial Intelligence, Cybersecurity, and Computing",
            "source": {
                "label": "USF 2026-2027 Undergraduate Catalog, Bellini College of Artificial Intelligence, Cybersecurity, and Computing",
                "url": "https://catalog.usf.edu/content.php?catoid=25&navoid=5248"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence (AI)",
                    "degree": "B.S.A.I."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S.C.P."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S.C.S."
                },
                {
                    "name": "Computer Science and Business",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science and Criminology",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science and Engineering",
                    "degree": "B.S.C.S.E."
                },
                {
                    "name": "Computer Science and Interdisciplinary Social Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Cybersecurity",
                    "degree": "B.S.C.Y.S."
                },
                {
                    "name": "Information Technology",
                    "degree": "B.S.I.T."
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "USF 2026-2027 Undergraduate Catalog, College of Arts and Sciences",
                "url": "https://catalog.usf.edu/content.php?catoid=25&navoid=4201"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Anthropology",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Cognitive Science",
                    "degree": "B.S."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Digital Communication and Multimedia Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Econometrics and Quantitative Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science and Policy",
                    "degree": "B.S."
                },
                {
                    "name": "Geography and Geographic Information Systems",
                    "degree": "B.A."
                },
                {
                    "name": "Geology",
                    "degree": "B.A."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Humanities and Cultural Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Information Science",
                    "degree": "B.S."
                },
                {
                    "name": "Integrated Public Relations and Advertising",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Natural Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Social Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Marine Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Mass Communications",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics: Computational and Applied",
                    "degree": "B.S."
                },
                {
                    "name": "Medical Laboratory Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physical Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Physical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Professional and Technical Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Religion and Health",
                    "degree": "B.S."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics",
                    "degree": "B.A."
                },
                {
                    "name": "Sustainability Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "B.A."
                },
                {
                    "name": "World Languages and Cultures",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Behavioral and Community Sciences",
            "source": {
                "label": "USF 2026-2027 Undergraduate Catalog, College of Behavioral and Community Sciences",
                "url": "https://catalog.usf.edu/content.php?catoid=25&navoid=4140"
            },
            "majors": [
                {
                    "name": "ASL Interpreting",
                    "degree": "B.A."
                },
                {
                    "name": "Behavioral Healthcare",
                    "degree": "B.S."
                },
                {
                    "name": "Criminology",
                    "degree": "B.A."
                },
                {
                    "name": "Health Care Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Language, Speech, and Hearing Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                }
            ]
        },
        {
            "name": "College of Design, Art, and Performance",
            "source": {
                "label": "USF 2026-2027 Undergraduate Catalog, College of Design, Art, and Performance",
                "url": "https://catalog.usf.edu/content.php?catoid=25&navoid=4148"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.Des."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.F.A."
                },
                {
                    "name": "Design",
                    "degree": "B.S."
                },
                {
                    "name": "Graphic Arts",
                    "degree": "B.F.A"
                },
                {
                    "name": "Music Education",
                    "degree": "B.S."
                },
                {
                    "name": "Music Performance",
                    "degree": "B.M."
                },
                {
                    "name": "Music Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Musical Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "USF 2026-2027 Undergraduate Catalog, College of Education",
                "url": "https://catalog.usf.edu/content.php?catoid=25&navoid=4142"
            },
            "majors": [
                {
                    "name": "Computer Science Education (K-12)",
                    "degree": "B.S."
                },
                {
                    "name": "Early Childhood Education (ESOL and Reading Endorsements)",
                    "degree": "B.S."
                },
                {
                    "name": "Elementary Education (ESOL and Reading Endorsements)",
                    "degree": "B.S."
                },
                {
                    "name": "English Education (ESOL and Reading Endorsements)",
                    "degree": "B.S."
                },
                {
                    "name": "Exceptional Student Education (ESOL and Reading Endorsements)",
                    "degree": "B.S."
                },
                {
                    "name": "Exercise Science and Kinesiology",
                    "degree": "B.S."
                },
                {
                    "name": "Informal and Community-Based/K-6 Elementary Education",
                    "degree": "B.S."
                },
                {
                    "name": "K-6 Elementary and K-12 Exceptional Student Education (w/ Reading and ESOL Endorsements)",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics Education",
                    "degree": "B.S."
                },
                {
                    "name": "Physical Education",
                    "degree": "B.A."
                },
                {
                    "name": "Physical Education",
                    "degree": "B.S."
                },
                {
                    "name": "Science Education",
                    "degree": "B.S."
                },
                {
                    "name": "Social Science Education",
                    "degree": "B.S."
                },
                {
                    "name": "Studies in Education",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "USF 2026-2027 Undergraduate Catalog, College of Engineering",
                "url": "https://catalog.usf.edu/content.php?catoid=25&navoid=4143"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S.A.E."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S.B.E."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S.C.H."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S.C.E."
                },
                {
                    "name": "Computer Engineering Systems",
                    "degree": "B.S.Cp.E."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S.E.E."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S.E.V."
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "B.S.I.E."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.M.E."
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "USF 2026-2027 Undergraduate Catalog, College of Nursing",
                "url": "https://catalog.usf.edu/content.php?catoid=25&navoid=4145"
            },
            "majors": [
                {
                    "name": "Nursing: Accelerated Second Bachelor's Degree Pathway",
                    "degree": "B.S.N."
                },
                {
                    "name": "Nursing: Upper Division Pathway",
                    "degree": "B.S.N."
                },
                {
                    "name": "Nursing: V-CARE",
                    "degree": "B.S.N."
                }
            ]
        },
        {
            "name": "College of Public Health",
            "source": {
                "label": "USF 2026-2027 Undergraduate Catalog, College of Public Health",
                "url": "https://catalog.usf.edu/content.php?catoid=25&navoid=4146"
            },
            "majors": [
                {
                    "name": "Health Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Health and Nutrition Science",
                    "degree": "B.S."
                },
                {
                    "name": "Health and Physical Rehabilitation Science",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Muma College of Business",
            "source": {
                "label": "USF 2026-2027 Undergraduate Catalog, Muma College of Business",
                "url": "https://catalog.usf.edu/content.php?catoid=25&navoid=4141"
            },
            "majors": [
                {
                    "name": "Accountancy and Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Advertising",
                    "degree": "B.S."
                },
                {
                    "name": "Artificial Intelligence (AI) and Business Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Business Analytics and Information Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Fintech",
                    "degree": "B.S."
                },
                {
                    "name": "General Business Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Global Business",
                    "degree": "B.A."
                },
                {
                    "name": "Hospitality Management",
                    "degree": "B.S."
                },
                {
                    "name": "Information Assurance and Cybersecurity Management",
                    "degree": "B.S."
                },
                {
                    "name": "Management",
                    "degree": "B.S."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S."
                },
                {
                    "name": "Personal Financial Planning",
                    "degree": "B.S."
                },
                {
                    "name": "Risk Management and Insurance",
                    "degree": "B.S."
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Undergraduate Studies",
            "source": {
                "label": "USF 2026-2027 Undergraduate Catalog, Undergraduate Studies",
                "url": "https://catalog.usf.edu/content.php?catoid=25&navoid=4149"
            },
            "majors": [
                {
                    "name": "Applied Science",
                    "degree": "B.S.A.S."
                },
                {
                    "name": "General Studies",
                    "degree": "B.G.S."
                }
            ]
        }
    ]
};

export default majors;
